module.exports = __webpack_public_path__ + "static/logo-684912c3dcde8fb1038e26f3eb9483d7.png";